import { connect } from 'react-redux';
import AdvancedSettings from 'components/AdvancedSettings/AdvancedSettings';
import { userSettingsActions, initActions } from '@lifesize/nucleus';
import _get from 'lodash/get';

const mapStateToProps = (state) => ({
  enableTcpTunneling: _get(state, 'nucleus.userSettings.enableTcpTunneling'),
  maxBandwidth: _get(state, 'nucleus.galaxy.options.maxBandwidth')
});

const mapDispatchToProps = (dispatch) => ({
  toggleTcpTunneling: (toggle) => {
    dispatch(userSettingsActions.updateCurrentUserSettings({ enableTcpTunneling: toggle }));
    dispatch(initActions.initialize({ forceTcpTunneling: toggle }));
  },
  onMaxBandwidthChange: (value) => {
    dispatch(initActions.initialize({ maxBandwidth: Number(value) }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AdvancedSettings);
